export const demoPhotos = [
  {
    id: "demo-autumn",
    title: "晚风经过江边",
    capturedAt: "2026-08-07T18:42:00+08:00",
    location: "上海 · 徐汇",
    solarTerm: "立秋",
    styles: ["柔光", "胶片"],
    thumbUrl: "/images/autumn-railway.jpg",
    originalUrl: "/images/autumn-railway.jpg",
    width: 1184,
    height: 864,
    isDemo: true,
  },
  {
    id: "demo-summer",
    title: "云在回家",
    capturedAt: "2026-06-21T18:15:00+08:00",
    location: "杭州 · 西湖",
    solarTerm: "夏至",
    styles: ["晴空", "风景"],
    thumbUrl: "/images/summer-clouds.jpg",
    originalUrl: "/images/summer-clouds.jpg",
    width: 1184,
    height: 864,
    isDemo: true,
  },
  {
    id: "demo-spring",
    title: "风把春天吹近",
    capturedAt: "2026-03-20T07:12:00+08:00",
    location: "东京 · 目黑",
    solarTerm: "春分",
    styles: ["樱花", "柔焦"],
    thumbUrl: "/images/spring-sakura.jpg",
    originalUrl: "/images/spring-sakura.jpg",
    width: 1184,
    height: 864,
    isDemo: true,
  },
  {
    id: "demo-winter",
    title: "雪落下以后",
    capturedAt: "2026-12-21T20:04:00+08:00",
    location: "札幌",
    solarTerm: "冬至",
    styles: ["夜色", "静谧"],
    thumbUrl: "/images/winter-snow.jpg",
    originalUrl: "/images/winter-snow.jpg",
    width: 1184,
    height: 864,
    isDemo: true,
  },
  {
    id: "demo-portrait",
    title: "镜头背后",
    capturedAt: "2026-04-04T16:20:00+08:00",
    location: "东京",
    solarTerm: "清明",
    styles: ["人像", "自然光"],
    thumbUrl: "/images/photographer-portrait.jpg",
    originalUrl: "/images/photographer-portrait.jpg",
    width: 864,
    height: 1184,
    isDemo: true,
  },
];
